import PropTypes from 'prop-types';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

const SectionHeadingBody = ({ title }) => (
  <div className="mceTmpl heading-fullwidth-container">
    <div className="heading-fullwidth-inner-container">
      <h3>{title}</h3>
    </div>
  </div>
);

SectionHeadingBody.propTypes = {
  title: PropTypes.string.isRequired,
};

const View = ({ data, className }) => (
  <div className={className}>
    <SectionHeadingBody title={data.title} />
  </div>
);

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string,
};

export default withBlockExtensions(View);
export { SectionHeadingBody };
